<template>
  <div class="lp3-products">
    <div class="logo p-1 mb-3">
      <img
        src="@/assets/images/logo/logo.png"
        alt="boho logo"
        width="100"
      >
    </div>
    <p
      class="products-title"
      style="color: #fff !important;"
    >
      {{ $t('lps.product.chooseProductText') }}
    </p>
    <div
      v-for="product in products"
      :key="product.product.productId"
      class="pack"
      :class="{popular: product.popular}"
      @click="$emit('updateSelectedProduct', { ...product })"
    >
      <div
        v-if="product.product.productId === selectedProduct.id"
        class="pack-selected"
      />
      <div
        :class="product.popular ? 'popular-tag' : 'pack-title'"
        style="color: #AC33F4 !important;"
        :style="product.popular ? ' border-bottom: 3px solid #AC33F4; background-color: #fff !important;' : ''"
      >
        {{ $t(product.name) }}
      </div>
      <div
        v-if="product.discount"
        class="discount-tag"
      >
        <span>
          %{{ product.discount }}
        </span>
        <img
          src="@/assets/images/lps/percent.png"
          alt="percent"
        >
      </div>
      <div class="pack-content">
        <div class="pack-details">
          <span
            class="radio"
            :class="{selected: product.product.productId === selectedProduct.id}"
          />
          <span class="diamonds">
            {{ numberFormat(product.product.credits) }} {{ $t('Diamonds') }}
            <b-img
              :src="iconDiamonds3"
              height="24"
            />
          </span>
        </div>
        <div class="price">
          <div class="current-price">
            {{ product.product.currency === 'USD' ? '$' : '&#8378;' }}
            {{ product.product.amount }}
          </div>
          <div class="original-price">
            {{ product.product.currency === 'USD' ? '$' : '&#8378;' }}
            {{ getOldPrice(product) }}
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 0 10px">
      <b-button
        class="mt-2"
        variant="primary"
        style="background-color: #00E380 !important; color: #fff !important; padding: 16px; border-radius: 16px;"
        block
        @click="selectedProduct ? $emit('nextStep') : null"
      >
        {{ $t('Continue') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BImg,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import { numberFormat } from '@/helpers/helpers'

const iconDiamonds3 = require('@/assets/images/icons/diamonds-3.svg')

export default {
  name: 'Lp3Products',
  components: {
    BImg,
    BButton,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    products: {
      type: Array,
      default: () => ([]),
    },
    selectedProduct: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      iconDiamonds3,
    }
  },
  methods: {
    numberFormat,
    getOldPrice(product) {
      let discountRate = 0.4

      if (product.discount) {
        // eslint-disable-next-line radix
        discountRate = parseFloat(parseInt(product.discount) / 100)
      }
      const basePrice = Math.floor(parseFloat(product.product.amount / (1 - discountRate)) / 10) * 10

      // eslint-disable-next-line radix
      return (basePrice + 9.99).toFixed(2)
    },
  },
}
</script>

<style scoped lang="scss">
.lp3-products {
  background-color: #b962ed;
  padding: 16px;
  min-height: 100vh;

  .logo {
    text-align: center;
    -webkit-text-fill-color: transparent;
  }

  .popular-tag {
    background-color: #fff !important;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    color: #AC33F4 !important;
    font-size: 16px;
    border-bottom: 3px solid #AC33F4;
  }
}
</style>
